import { FormAtylBase } from '../../form-atyl-base'

export class AtylDateRange extends FormAtylBase<string> {
	controlType = 'daterange';
	type: string
	options: string[] = [];

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
